import React from 'react';
import "../CSS/ifram-style.css"

const ExternalPdfViewer = ({ fileUrl }) => {
    return (
        <div className="pdf-container">
            <iframe
                src={fileUrl}

                className="pdf-frame"
            >
                Your browser does not support PDFs.
            </iframe>
        </div>
    );
};

export default ExternalPdfViewer;
